const data = {
  translation: {
    lbl_welcome: "Bienvenue à",
    lbl_hodo_community_events: "Événements communautaires HODO",
    lbl_setup_sound_and_video:
      "Installer l'équipement audio et vidéo avant de participer",
    lbl_join_room: "Rejoindre la salle",
    lbl_join_studio: "Rejoindre le studio",
    lbl_join_conference: "Rejoindre la conférence",
    lbl_enter_name: "Entrez votre nom",
    lbl_on: "Activé",
    lbl_off: "Désactivé",
    lbl_change_camera: "Basculer caméra avant/arrière",
    lbl_add_virtual_background: "Ajouter un arrière-plan virtuel",
    lbl_vietnamese: "Vietnamienne",
    lbl_english: "Anglais",
    lbl_french: "Français",
    gender: {
      male: "Homme",
      female: "Femme",
      unknown: "Inconnu",
    },
    lbl_setting_device: "Réglages de l'appareil",
    lbl_notification: "Notification",
    lbl_view_layout: "Vue Mise en page",
    lbl_audio_device: "Équipements audio",
    lbl_speaker: "Haut-parleur",
    lbl_test: "Test",
    lbl_noise_suppression: "Suppression de bruit",
    lbl_participants: "Les participants",
    lbl_the_leaver: "Le partant",
    lbl_new_message: "Nouveau message",
    lbl_peer_joined: "Participant rejoint",
    lbl_peer_leave: "Un pair a quitté",
    lbl_hand_raiser: "Leveur de main",
    lbl_error: "Erreur",
    lbl_active_speaker_mode: "Mode haut-parleur en cours",
    lbl_active_speaker_sorting: "Tri des intervenants actifs",
    lbl_arranging_active_speakers: "Disposition des haut-parleurs actifs",
    lbl_audio_only_mode: "Mode audio uniquement",
    lbl_personal_video_mirror: "Miroir vidéo personnel",
    lbl_personal_video_hidden: "Vidéo personnelle cachée",
    lbl_error_check_role:
      "Erreur lors de la vérification des rôles d'utilisateur",
    lbl_meting: "Réunion",
    lbl_room_code_is_disabled: "Le code de la salle est désactivé",
    lbl_room_code_does_not_exist: "Le code de la salle n'existe pas",
    lbl_endpoint_is_not_reachable: "Le point de terminaison est injoignable",
    lbl_room_does_not_exist: "La salle n'existe pas",
    lbl_accessing_disabled:
      "L'accès à la salle via ce format de lien est désactivé",
    lbl_error_fetching_token: "Erreur lors de la récupération du jeton",
    lbl_deactivate: "Désactiver",
    fm_toggle_interpretation: "Choisissez d'écouter l'interprétation",
    lbl_other_options: "Un autre choix",
    lbl_setting: "Paramètre",
    lbl_you: "Toi",
    lbl_have_a_nice_day: "Passe une bonne journée",
    msg_you_left: "Vous avez quitté le {{type}}",
    lbl_left_by_mistake: "Vous êtes parti par erreur ?",
    btn_rejoin: "Rejoindre",
    msg_back_to_home: "Retour à l'accueil",
    lbl_join_again: "Vous souhaitez rejoindre à nouveau",
    lbl_click_here: "Cliquez ici",
    lbl_stream: "flux",
    lbl_room: "salle",
    lbl_rename: "Renommer",
    lbl_change_role: "Changer de rôle",
    lbl_change_my_role: "Changer mon rôle",
    lbl_mute_all: "Couper le son de tous",
    lbl_exit: "Quitter",
    lbl_leave_room: "Quitter la salle",
    lbl_leave_studio: "Quitter le studio",
    lbl_end_room: "Terminer la salle",
    lbl_end_room_for_all: "Terminer la salle pour tous",
    lbl_disable_future_joins: "Désactiver les futures connexions",
    lbl_url_embed: "URL intégrée",
    lbl_email: "Email",
    ph_email_example: "vous@entreprise.com",
    lbl_password: "Mot de passe",
    ph_password: "Votre mot de passe",
    lbl_cancel: "Annuler",
    lbl_change: "Modifier",
    lbl_update_embed: "Mettre à jour l'intégration",
    lbl_stop_embed: "Arrêter l'intégration",
    lbl_embed_and_share: "Intégrer et partager",
    lbl_change_multiple_role: "Modifier plusieurs rôles",
    lbl_select_role: "Choisir un rôle",
    lbl_select_language: "Choisir la langue",
    preview: {
      room_protected: "Salle protégée",
      enter_password: "Entrez le mot de passe",
      submit: "Envoyer",
      password_incorrect: "Mot de passe incorrect",
      get_started: "Commencer",
      setup_audio_before_joining:
        "Configurez votre audio et votre vidéo avant de rejoindre",
    },
    lbl_select_emoji: "Choisir un emoji",
    lbl_reactions_timed_live_viewers:
      "Les réactions seront synchronisées pour les spectateurs du streaming en direct.",
    lbl_audio_player: "Lecteur audio",
    lbl_audio_playlist: "Liste de lecture audio",
    lbl_video_playlist: "Liste de lecture vidéo",
    lbl_playlist_music: "Musique de la liste de lecture",
    lbl_whiteboard: "Tableau blanc",
    lbl_copied: "Copié",
    lbl_copy: "Copier",
    lbl_copy_details: "Copier les détails",
    lbl_copy_error_details: "Copier les détails de l'erreur",
    lbl_copy_failed: "Échec de la copie",
    lbl_copy_invite_link: "Copier le lien d'invitation",
    lbl_select_multiple_role: "Choisir plusieurs rôles",
    lbl_become_role: "Devenir :",
    lbl_my_screen: "Mon écran",
    lbl_link_copied: "Lien copié !",
    lbl_signal: "Signal faible",
    lbl_mute_mic: "Vous êtes en sourdine",
    lbl_participants_1: "Participants",
    lbl_no_participants: "Il n'y a aucun participant",
    lbl_no_suitable_participants: "Il n'y a pas de participants appropriés",
    lbl_search_participants: "Entrez les informations de recherche",
    lbl_all: "Tous",
    lbl_change_permissions: "Modifier les autorisations",
    lbl_remove_participants: "Retirer des participants",
    lbl_change_role_of: "Changer le rôle de",
    lbl_become: "devenir",
    lbl_submit_request_confirm: "Envoyer la demande de confirmation",
    lbl_pin: "Épingler",
    lbl_unpin: "Retirer l'épingle",
    lbl_outstanding_position_for_everyone:
      "Position mise en avant pour tout le monde",
    lbl_removed_from_prominent_position: "Retiré de la position mise en avant",
    lbl_connected_now: "Vous êtes maintenant connecté",
    lbl_open_chat: "Ouvrir le chat",
    lbl_welcome_joined: "Bienvenue, vous avez rejoint",
    lbl_person_first: "Vous êtes la première personne à rejoindre la salle",
    lbl_sit_down:
      "Veuillez vous asseoir et vous détendre jusqu'à l'arrivée des autres",
    lbl_reload_page: "Recharger la page",
    lbl_reload: "Recharger",
    lbl_device_settings: "Paramètres de l'appareil",
    lbl_notifications: "Notifications",
    lbl_settings: "Paramètres",
    lbl_attention: "Attention",
    msg_hls_autoplay:
      'Le navigateur demande une confirmation pour lire le flux HLS. Cliquez sur "Lire le flux" pour continuer.',
    btn_play_stream: "Lire le flux",
    lbl_permission_error: "Erreur d'autorisation",
    msg_autoplay_audio:
      "Le navigateur demande une confirmation pour lire l'audio. Veuillez autoriser l'audio pour continuer.",
    btn_allow_audio: "Autoriser l'audio",
    lbl_request_permission: "Demander l'autorisation",
    lbl_please_wait: "Veuillez patienter",
    msg_waiting_relax:
      "Veuillez patienter pendant que les autres vous laissent rejoindre.",
    msg_reconnect_trying:
      "Vous avez perdu la connexion réseau. Tentative de reconnexion.",
    msg_sharing_screen: "Vous partagez votre écran",
    btn_stop_screen_share: "Arrêter le partage d'écran",
    msg_end_recording_warning:
      "Êtes-vous sûr de vouloir arrêter l'enregistrement ? Cette action est irréversible.",
    btn_dont_end: "Ne pas arrêter",
    btn_end_recording: "Arrêter l'enregistrement",
    lbl_rtmp_url: "URL RTMP",
    ph_enter_rtmp_url: "Entrez l'URL RTMP",
    lbl_stream_key: "Clé de diffusion",
    ph_enter_stream_key: "Entrez la clé de diffusion",
    btn_end_stream: "Arrêter la diffusion",
    msg_waiting_for_stream: "En attente du démarrage du flux...",
    btn_vote: "Voter",
    lbl_polls_quiz: "Sondage/Quiz",
    msg_select_poll_type: "Sélectionnez le type que vous souhaitez utiliser",
    lbl_hide_vote_count: "Masquer le nombre de votes",
    lbl_make_results_anonymous: "Rendre les résultats anonymes",
    btn_create_poll: "Créer un sondage",
    btn_create_quiz: "Créer un quiz",
    lbl_previous_polls_quiz: "Sondages/Quiz précédents",
    btn_view: "Voir",
    btn_add_another_question: "Ajouter une autre question",
    btn_launch_quiz: "Lancer le quiz",
    btn_launch_poll: "Lancer le sondage",
    ph_enter_your_answer: "Entrez votre réponse",
    btn_skip: "Passer",
    lbl_skipped: "Ignoré",
    lbl_submitted: "Soumis",
    lbl_voted: "A voté",
    btn_submit: "Soumettre",
    lbl_track_unmute_request: "Track Unmute Request",
    msg_track_unmute_body:
      "{{name}} has requested you to unmute your {{source}} {{type}}.",
    lbl_widgets: "Widgets",
    lbl_poll_quiz: "Sondage/Quiz",
    msg_poll_quiz_subtitle: "Découvrez ce que pensent les autres",
    btn_share_music: "Partager la musique",
    btn_stop_sharing_music: "Arrêter le partage de musique",
    msg_play_music_from:
      "Jouer de la musique depuis Spotify ou un autre onglet",
    msg_stop_playing_music:
      "Arrêter la lecture de musique depuis Spotify ou un autre onglet",
    lbl_open_meeting_report: "Ouvrir le rapport de réunion",
    lbl_close_meeting_report: "Fermer le rapport de réunion",
    lbl_layout: "Mise en page",
    tooltip_hide_sidebar: "Masquer la barre latérale",
    tooltip_show_sidebar: "Afficher la barre latérale",
    lbl_browse: "Parcourir",
    lbl_need_help: "Besoin d'aide?",
    lbl_more: "Plus",
    lbl_learn_more: "En savoir plus",
    lbl_share: "Partager",
    lbl_start_sharing: "Commencer le partage",
    lbl_choose_what_to_share: "Choisissez ce que vous souhaitez partager",
    msg_share_your_tab:
      "Partagez votre onglet, votre fenêtre ou l'intégralité de votre écran",
    lbl_share_pdf: "Partager le PDF",
    msg_annotate_pdf: "Annoter, dessiner des formes et plus encore sur les PDF",
    btn_go_back: "Retour",
    btn_start_sharing: "Commencer le partage",
    lbl_start_screen_sharing: "Démarrer le partage d'écran",
    lbl_stop_screen_sharing: "Arrêter le partage d'écran",
    lbl_invite_people: "Inviter des personnes",
    lbl_go_live: "Aller en direct",
    lbl_live: "EN DIRECT",
    lbl_hls_starting: "Démarrage HLS en cours",
    lbl_hls_streaming: "Diffusion HLS",
    lbl_hls_streaming_description:
      "Diffusez directement depuis le navigateur en utilisant n'importe quel appareil avec plusieurs hôtes et messagerie en temps réel, le tout sur cette plateforme.",
    lbl_rtmp_starting: "Démarrage RTMP en cours",
    lbl_start_streaming: "Commencer la diffusion",
    lbl_starting_stream: "Démarrage du stream...",
    lbl_cannot_start_recording_once_stream_starts:
      "Vous ne pouvez pas démarrer l'enregistrement une fois la diffusion commencée ; vous devrez arrêter la diffusion pour activer l'enregistrement.",
    lbl_start_conversation: "Commencer la conversation",
    lbl_tiles_in_view: "Tuiles affichées",
    lbl_switch_camera: "Changer de caméra",
    lbl_hide_local_video: "Masquer la vidéo locale",
    lbl_mirror_local_video: "Miroir vidéo local",
    lbl_screenshare: "Partager l'écran",
    lbl_activate_presentation_slides:
      "Activer les diapositives de présentation",
    lbl_deactivate_presentation_slides:
      "Désactiver les diapositives de présentation",
    lbl_screenshare_audio: "Audio du partage d'écran",
    msg_playlist_is_playing: "La liste de lecture est en cours",
    msg_music_is_playing: "La musique est en cours",
    lbl_invalid_url: "URL invalide!",
    lbl_select_maximum_resolution: "Choisir la résolution maximale",
    lbl_resolution_width: "Largeur",
    lbl_resolution_height: "Hauteur",
    lbl_currently_streaming: "Actuellement en streaming :",
    lbl_low: "Faible",
    lbl_medium: "Moyen",
    lbl_high: "Élevé",
    lbl_sharing_screen: "Vous partagez votre écran",
    lbl_stop_share: "Arrêter le partage d'écran",
    msg_error_check_role:
      "Une erreur s'est produite lors de la vérification de votre rôle. Veuillez vérifier votre rôle ou contacter l'équipe Circle pour plus de détails.",
    msg_end_room_warning: "Attention : vous ne pouvez pas annuler cette action",
    msg_can_rejoin_later: "Vous pouvez toujours vous reconnecter plus tard",
    msg_room_code_is_disabled:
      "Le code de la salle correspondant à ce lien n'est plus actif.",
    msg_room_code_does_not_exist:
      "Nous n'avons pas pu trouver de code de salle correspondant à ce lien.",
    msg_room_does_not_exist:
      "Nous n'avons pas pu trouver de salle correspondant à ce lien.",
    msg_accessing_disabled:
      "Vous pouvez réactiver cela depuis la section développeur du tableau de bord.",
    msg_error_fetching_token:
      "Une erreur s'est produite lors de la récupération du jeton de l'application. Veuillez consulter les journaux pour plus de détails.",
    msg_embed:
      "Intégrez l'URL et partagez-la avec tout le monde dans la salle. Assurez-vous de partager l'onglet actuel lorsque l'invite s'ouvre. Notez que tous les sites Web ne prennent pas en charge l'intégration.",
    fm_toggle_sound: "{{status}} micro ({{key}} + d)",
    fm_toggle_video: "{{status}} vidéo ({{key}} + e)",
    fm_toggle_background: "{{status}} arrière-plan virtuel",
    fm_gird_layout_view: "Grille en vue({{count}})",
    fm_toggle_pip: "{{status}} le mode image dans l'image",
    fm_interpretation_end:
      "La traduction de {{text1}} est terminée. Vous êtes redirigé pour écouter {{text2}}",
    fm_interpretation_select: "Vous avez choisi d'écouter {{text}}",
    fm_you_have_left_cabin: "Vous avez quitté la cabine",
    fm_not_connect_room: "Impossible de se connecter à {{name}}",
    fm_endpoint_is_not_reachable:
      "Le point de terminaison est injoignable. {{desc}}",
    fm_you_out_room: "Vous avez quitté la salle {{name}}",
    fm_fullscreen: "{{action}} plein écran",
    fm_open_chat: "{{action}} chat",
    fm_you_content: "Vous ({{content}})",
    fm_toggle_fullscreen: "{{text}} plein écran",
    fm_toggle_sharescreen: "{{text}} partage d'écran",
    fm_volume: "Volume {{number}}",
    fm_pin_screen: "{{action}} cadre",
    fm_block_permission: "La permission {{device}} a été bloquée",
    fm_access_permission: "L'accès à {{device}} est requis.",
    fm_accept_permission_system:
      "Activer les autorisations de {{device}} à partir du système",
    fm_accept_permission_browser:
      "Activer les autorisations de {{device}} depuis la barre d'adresse ou les paramètres du navigateur",
    fm_hands_up: "{{name}} a levé la main",
    fm_hands_up_multiple:
      "{{name}} et {{number}} autres personnes ont levé la main",
    fm_joined: "{{name}} a rejoint",
    fm_left: "{{name}} a quitté",
    fm_left_multiple: "{{name}} et {{number}} autres personnes ont quitté",
    fm_new_message: "Nouveau message de {{name}}",
    fm_new_message_multiple: "{{number}} nouveaux messages",
    fm_offline:
      "Vous êtes maintenant hors ligne, pendant que nous essayons de nous reconnecter, veuillez vérifier votre connexion Internet. {{message}}",
    fm_reconnected: "Vous êtes maintenant connecté",
    fm_reconnecting:
      "Vous êtes hors ligne pour le moment. Pendant que nous essayons de nous reconnecter, veuillez vérifier votre connexion Internet. {{message}}",
    fm_role_changed: "{{name}} est maintenant {{role}}",
    fm_others_role_changed:
      "{{name}} et {{number}} autres sont maintenant {{role}}",
    fm_others_joined: "{{name}} et {{number}} autres ont rejoint",
    fm_others_left: "{{name}} et {{number}} autres ont quitté",
    fm_raised_hand: "{{name}} a levé la main",
    fm_others_raised_hand: "{{name}} et {{number}} autres ont levé la main",
    fm_start: "Commencer",
    fm_stop: "Arrêt",
    lbl_no_msg: "Pas de messages",
    lbl_hands_up: "Lever la main",
    lbl_hands_down: "Baisser la main",
    lbl_open: "Ouvrir",
    lbl_close: "Fermer",
    lbl_activate: "Activer",
    lbl_everyone: "Tout le monde",
    lbl_new_msgs: "Nouveaux messages",
    lbl_find_participants: "Trouver des participants",
    lbl_roles: "Les rôles",
    lbl_participant: "Participants",
    lbl_write_smt_here: "Veuillez saisir un message",
    lbl_toggle_all_remote_audio_devices:
      "Couper/Réactiver le son des appareils audio distants",
    lbl_all_roles: "Tous les rôles",
    lbl_track_type: "Type de piste",
    lbl_track_source: "Source de la piste",
    lbl_track_status: "État du suivi",
    lbl_mute: "Muet",
    lbl_unmute: "Demande de réactiver le son",
    lbl_apply: "Appliquer",
    lbl_all_sources: "Toutes les sources",
    lbl_all_devices: "À nouveau tous les appareils",
    lbl_strangers: "Étranger",
    lbl_pin_msg: "Épingler le message",
    lbl_more_options: "Plus d'options",
    lbl_toggle_widget_menu: "Afficher/masquer le menu des widgets",
    lbl_change_name: "Changer le nom",
    lbl_bulk_role_change: "Modifier plusieurs rôles",
    lbl_fullscreen_enter: "Passer en plein écran",
    lbl_fullscreen_exit: "Quitter le plein écran",
    lbl_show_hls_stats: "Afficher les statistiques HLS",
    lbl_stats_for_nerds: "Statistiques pour Nerds",
    lbl_show_stats_on_tiles: "Afficher les statistiques sur les tuiles",
    lbl_stats_for: "Statistiques pour",
    ph_select_stats: "Sélectionnez les statistiques",
    lbl_private: "PRIVÉ",
    lbl_to: "À",
    fm_to_peer: "À {{peer}}",
    fm_to_you: "À VOUS",
    lbl_no_messages_here: "Il n'y a pas de messages ici",
    lbl_embed_url: "URL intégrée",
    lbl_url: "URL",
    lbl_embed_url_help:
      "Intégrez une URL et partagez-la avec tout le monde dans la salle. Assurez-vous de partager l'onglet actuel lorsque l'invite s'ouvre. Notez que tous les sites Web ne prennent pas en charge l'intégration.",
    lbl_raise_hand: "Lever la main",
    lbl_unraise_hand: "Baisser la main",
    lbl_im_back: "Je suis de retour",
    lbl_ill_be_right_back: "Je reviens tout de suite",
    lbl_spotlight_remove: "Retirer du Spotlight",
    lbl_spotlight_for_everyone: "Mettre en lumière pour tout le monde",
    lbl_tile_for_myself: "Tuile pour moi",
    obj_roles: {
      lbl_presenter: "Présentateur",
      lbl_host: "Hôte",
      lbl_broadcaster: "Diffuseur",
      lbl_panelist: "Panéliste",
      lbl_translator: "Interprète",
      "lbl_e-v": "Anglais - Vietnamien",
      "lbl_f-v": "Français - Vietnamien",
      lbl_vietnamese: "Vietnamienne",
      lbl_guest: "Invité",
      "lbl_guest-advanced": "Invité (avancé)",
      lbl_viewer: "Téléspectateur",
      "lbl_hls-viewer": "Téléspectateur",
    },
    lbl_waiting_for_the_live_stream_to_start:
      "En attendant le début du livestream",
    lbl_live_streaming: "Diffusion en direct",
    lbl_sign_in: "Se connecter",
    lbl_sign_in_desc: "Connectez-vous pour continuer vers votre réunion",
    lbl_logout: "Se déconnecter",
    lbl_anonymous: "Invité",
    sign_in: {
      auto_failed:
        "Échec de la connexion automatique. Veuillez vous connecter manuellement.",
      no_token: "Échec de la connexion : aucun jeton retourné",
      wrong_password: "Email ou mot de passe incorrect. Veuillez réessayer.",
      login_failed: "Échec de la connexion",
    },
    lbl_keep_signed_in: "Rester connecté",
    lbl_forgot_password: "Mot de passe oublié?",
    lbl_help: "Aide",
    lbl_stream_management: "Gestion du streaming",
    lbl_stop_recording: "Arrête d'enregistrer",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Etes-vous sûr de vouloir mettre fin à l'enregistrement ?",
    lbl_stop: "Arrêt",
    lbl_starting_recording: "Démarrage de l'enregistrement",
    lbl_start_recording: "Commencer l'enregistrement",
    lbl_start: "Commencer",
    lbl_recording_already_running: "L'enregistrement est déjà en cours",
    lbl_browser_message:
      "Le navigateur demande une confirmation avant de lancer Live HODO. Cliquez sur « lire le flux » pour continuer.",
    err_sharing_embed: "Erreur lors du partage de l'URL intégrée {{message}}",
    lbl_select_quality: "Sélectionnez la qualité",
    lbl_auto: "Auto",
    lbl_play: "Lire",
    lbl_pause: "Pause",
    lbl_the_conference_will_start_in: "La conférence commencera dans",
    lbl_the_conference_will_begin_soon:
      "La conférence va bientôt commencer. \nVeuillez vous asseoir, vous reposer et vous détendre pendant le temps d'attente.",
    lbl_the_conference_has_ended:
      "La conférence est terminée, veuillez revenir à un autre moment. \nMerci !",
    lbl_you_can_connect_with_others:
      "Vous ne pouvez pas vous connecter avec les autres.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "Vous êtes connecté mais personne n'est actif dans le cercle.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Actuellement, il n'y a personne d'autre dans la pièce.",
    lbl_this_role_does_not_exist: "Ce rôle n'existe pas.",
    lbl_this_role_has_not_been_published: "Ce rôle n'a pas été publié.",
    lbl_presentation_screen: "Écran de présentation",
    lbl_members: "Membre",
    lbl_agenda: "Agenda",
    lbl_info: "Information",
    lbl_role_preside: "Preside",
    lbl_role_member: "Membre",
    lbl_role_expert: "Expert",
    lbl_role_secretary: "Secrétaire",
    lbl_mdt: "MDT",
    lbl_meetings: "Réunions",
    lbl_search_rooms: "Rechercher des salles par nom",
    lbl_all_meeting_rooms: "Tout",
    lbl_one_time_meeting_room: "Ponctuelle",
    lbl_daily_meeting_room: "Quotidien",
    lbl_weekly_meeting_room: "Hebdomadaire",
    fm_pagination: "Affichage de {{countItems}} sur {{totalItems}}",
    lbl_loading: "Chargement...",
    lbl_prev: "Préc",
    lbl_next: "Suiv",
    lbl_report: "Rapports",
    lbl_tqm: "FSMDT",
    lbl_tqm_short: "FSMDT",
    lbl_bbhc: "MDT",
    lbl_tttqm: "FSMDT",
    lbl_error_user_not_sign_in: "Erreur : utilisateur non connecté",
    msg_error_user_not_sign_in:
      "Veuillez vous connecter et rejoindre la salle de réunion via le portail de connexion {{domain}}",
    lbl_participants_meeting: "Participants",
    lbl_save_meeting_minutes: "Enregistrer les procès-verbaux des réunions",
    lbl_update_meeting_minutes: "Mettre à jour les procès-verbaux des réunions",
    lbl_doctor: "Médecin",
    lbl_patient: "Patient",
    lbl_checked_in: "Enregistré",
    lbl_not_checked_in: "Non enregistré",
    presentation: {
      menu: {
        bbhc: "Rapport MDT",
        tttqm: "Résumé opératoire",
        documents: "Documents / Analyses",
        imaging: "Imagerie médicale",
      },
      actions: {
        approve: "Approuver",
        cancel_approve: "Annuler l'approbation",
        pmdt_approve: "Approuver",
        pmdt_deny: "Refuser",
        pmdt_cancel: "Annuler",
        add: "Ajouter",
      },
      labels: {
        approved: "Approuvé",
        pmdt_approved: "Approuvé",
        presenter: "Présentateur",
        unknown: "Non défini",
        cases: "Nombre de cas : {{count}}",
      },
      fields: {
        admission_date: "Date d'admission:",
        diagnosis: "Diagnostic:",
        patient_name: "Nom du patient:",
        address: "Adresse:",
        dept: "Département:",
        summary: "Résumé du dossier:",
        treatment_progress: "Progression de la maladie / Résumé du traitement:",
        conclusion_note: "Conclusion (après révision et discussion)",
        conclusion: "Conclusion:",
        treatment: "Traitement ultérieur:",
        preside: "Préside:",
        age: "Âge:",
        gender: "Sexe:",
        mdt_time: "Heure MDT:",
        secretary: "Secrétaire:",
        members: "Participants",
        profile_code: "Code profil:",
        treatment_period: "Période de traitement:",
        tests_section: "II. Tests",
        test_group_blood: "1. Tests sanguins",
        test_ure: "Ure",
        test_bilirubin_tp: "Bilirubin TP",
        test_hst: "HST",
        test_creatinin: "Creatinin",
        test_bilirubin_tt: "Bilirubin TT",
        test_hc: "HC",
        test_glucose: "Glucose",
        test_got: "GOT",
        test_hct: "HCT",
        test_blood: "Groupe sanguin",
        test_protit: "Protit",
        test_gpt: "GPT",
        test_tc: "TC",
        test_pt: "PT%",
        test_cholesterol: "Cholesterol",
        test_blood_basic: "Coagulation de base",
        test_quick: "Quick",
        test_ggt: "GGT",
        test_urine: "2. Urine",
        test_xray: "3. Radiographie",
        test_electrocar: "4. Électrocardiogramme",
        test_ultrasound: "5. Échographie",
        test_endoscopy: "6. Endoscopie",
        test_drug_reaction: "1. Test de réaction aux médicaments",
        test_antibiotics: "2. Antibiotiques préopératoires",
        test_surgery_method: "3. Méthode chirurgicale",
        test_anaesthetic_method: "4. Méthode d'anesthésie",
        test_surgical_team: "5. Équipe chirurgicale",
        test_anaesthetic_team: "6. Équipe d'anesthésie",
        test_anatomic: "7. Anatomique",
        test_blood_plan: "8. Plan de sang",
        surgery_date: "Date estimée de la chirurgie",
        prognostic: "9. Pronostic",
        signatory_chief_anes: "Chef de l'anesthésie et de la récupération",
        signatory_chief_surgery: "Chef de chirurgie",
        signatory_treating_doctor: "Médecin traitant",
        select_doctor: "Choisir un médecin",
        preparation_section:
          "III. Préparation du patient et méthode de traitement",
      },
      errors: {
        approve_missing_bbhc:
          "Le rapport MDT n'est pas encore approuvé, vous ne pouvez pas approuver ce cas",
        missing_conclusion_treatment:
          "La conclusion et le traitement sont requis pour enregistrer le rapport MDT, veuillez mettre à jour",
        missing_operation_summary:
          "Le résumé opératoire n'est pas encore approuvé, veuillez ajouter ce rapport",
        no_bbhc: "Aucun rapport disponible",
        no_tttqm: "Aucun rapport disponible",
        no_document: "Document introuvable",
      },
      dialogs: {
        confirm_title: "Confirmer",
        confirm_body: "Êtes-vous sûr?",
        cancel: "Annuler",
        confirm: "Confirmer",
        bbhc_title: "Rapport MDT",
        tttqm_title: "Résumé opératoire",
        signatory_section_title: "Signataires",
        save: "Enregistrer",
        print: "Imprimer",
      },
      empty: "Aucune donnée",
      page: {
        title: "MDT",
        date_label: "Date:",
        participants_label: "Participants:",
        preside_label: "Préside:",
        approved_count: "Nombre de cas approuvés:",
        unapproved_count: "Nombre de cas non approuvés:",
      },
      toast: {
        cant_change_language:
          "Vous ne pouvez pas changer la langue de la présentation.",
        changed_language:
          "Vous avez changé la langue de la présentation en {{language}}.",
        no_case_selected: "Aucun cas sélectionné",
        no_case_data: "Aucune donnée de cas pour interroger SuperDoc",
        superdoc_failed: "Échec de SuperDoc",
        saved_success: "Enregistré avec succès",
      },
      superdoc: {
        failed_message: "Échec de SuperDoc. Veuillez réessayer plus tard.",
        fields: {
          summary_label: "Résumé du dossier",
          diagnosis_label: "Diagnostic",
          conclusion_label: "Conclusion",
          treatment_label: "Traitement ultérieur",
        },
      },
      patient_info:
        "{{name}} ({{gender}} - {{age}}) - Médecin responsable: {{doctor}}",
      case_label: "Cas {{number}}",
    },
    common: {
      success: "Succès",
    },
    superdoc_name: "SuperDoc",
    superdoc_greeting:
      "Bonjour ! Je suis SuperDoc. J'accompagne les cliniciens en fournissant des recommandations thérapeutiques et un soutien complet pour la prise en charge des patients.",
    superdoc_loading: "SuperDoc analyse les données...",
    superdoc_empty_message: "Veuillez saisir une question",
    signature: {
      select: "Choisir la signature",
      loading: "Chargement...",
      no_signatures: "Aucune signature trouvée",
      create: "Créer une signature",
      provider_by: "Fournisseur:",
      signed_on: "Signé le:",
      status: "Statut:",
      not_signed: "Non signé",
      warn_select_and_place:
        "Veuillez choisir une signature et la placer sur le document.",
      warn_select: "Veuillez choisir une signature.",
      alert_title: "Attention",
      err_cannot_load_document: "Impossible de charger le document.",
      err_failed_load_signatures: "Échec du chargement des signatures.",
      err_upload_signed_file: "Échec du téléchargement du document signé.",
      err_update_envelope:
        "Échec de la mise à jour du document après signature.",
      err_intrust_wrong_pin: "Code PIN incorrect. Veuillez réessayer.",
      err_intrust_sign_failed: "Échec de la signature : {{message}}",
      err_already_signing: "Une opération de signature est déjà en cours.",
      err_missing_secretary: "Informations du secrétaire introuvables",
      err_missing_president: "Informations du président introuvables",
      err_missing_treating_doctor:
        "Informations du médecin traitant introuvables",
      loading_data: "Chargement des données...",
      loading_pdf: "Chargement du PDF...",
    },
    intrust: {
      login_title: "Connexion IntrustCA",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      auth_method: "Méthode d'authentification",
      auth_pin: "PIN",
      auth_mobile: "Application mobile",
      logging_in: "Connexion en cours...",
      login: "Se connecter",
      login_missing: "Veuillez saisir le nom d'utilisateur et le mot de passe",
      login_failed:
        "Échec de la connexion. Veuillez vérifier vos identifiants.",
      cert_title: "Sélectionner le certificat IntrustCA",
      loading_certs: "Chargement des certificats...",
      no_certs: "Aucun certificat trouvé.",
      reload: "Recharger",
      pin_label: "Code PIN",
      pin_placeholder: "Entrez le code PIN",
      sign: "Signer",
      key_label: "Clé",
    },
  },
};

export default data;
